import React from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import arrowAngel from '../../assets/icons/arrowAngel.svg';
import removeHtmlTags from '../../helpers/removeHtmlTags';

function CareerCard({ openModal, item }) {
  const lang = Cookies.get('i18next') || 'en';
  const { translations } = useSelector((state) => state.translation);
  return (
    <div className="career-card">
      <div className="career-card-info">
        <p className="career-card-info-title">{item.title[lang]}</p>
        <p className="career-card-info-description">
          {removeHtmlTags(item.body[lang])}
        </p>
        <div className="career-card-info-tags">
          <div className="career-card-info-tag">
            <p>{item.position[lang]}</p>
          </div>
          <div className="career-card-info-tag">
            <p>
              {translations.last_date[lang]}
              :
              {' '}
              {item.last_date}
            </p>
          </div>
        </div>
      </div>
      <div className="career-card-action">
        <button onClick={openModal} className="career-card-action-button" type="button">
          <p className="career-card-action-button-text">{translations.apply[lang]}</p>
          <img className="career-card-action-button-icon" src={arrowAngel} alt="arrow angel" />
        </button>
      </div>
    </div>
  );
}

export default CareerCard;
